/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {SingleMaterialStatusComponent} from './single-material-status.component';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {TooltipModule} from '../tooltip/tooltip.module';

@NgModule({
    declarations: [
        SingleMaterialStatusComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        TooltipModule,
    ],
    exports: [SingleMaterialStatusComponent]
})

export class SingleMaterialStatusModule {
}
